export const cachedStringSearch = <T>(filterFn: (query: string) => T[]) => {
  let firstFailedQuery: string | null = null;

  return (query: string) => {
    const searchValue = (query ?? '').trim().toLowerCase();
    if (firstFailedQuery && query.startsWith(firstFailedQuery)) return [];

    const result = filterFn(searchValue);
    if (!result.length) {
      firstFailedQuery = query;
    }

    return result;
  };
};
